import { render, staticRenderFns } from "./VendorPrefixCall.vue?vue&type=template&id=5515785c&"
import script from "./VendorPrefixCall.vue?vue&type=script&lang=js&"
export * from "./VendorPrefixCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports